
import styled from 'styled-components';
import { Link } from'react-router-dom';

const ExploreButton = styled(Link)`
  display: inline-block;
  background: #007bff;
  color: white;
  text-decoration: none;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  font-family: 'DM Sans', sans-serif;
  transition: all 0.3s ease;
  
  &:hover {
    background: #0056b3;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0,123,255,0.3);
  }
`
function TestButton({contenido,destino}) {
  return (
    <div>
      <ExploreButton to={destino} >
        {contenido}
      </ExploreButton>
    </div>
  );
}
export default TestButton;